import SpaIcon from '@mui/icons-material/Spa'
import AssessmentIcon from '@mui/icons-material/Assessment'
import CategoryIcon from '@mui/icons-material/Category'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import GrassIcon from '@mui/icons-material/Grass'
import TerrainIcon from '@mui/icons-material/Terrain'
import SummarizeIcon from '@mui/icons-material/Summarize'
import AutoStoriesIcon from '@mui/icons-material/AutoStories'
import CalculateIcon from '@mui/icons-material/Calculate'
import EngineeringIcon from '@mui/icons-material/Engineering'
import ForestIcon from '@mui/icons-material/Forest'
import GroupIcon from '@mui/icons-material/Group'
import HistoryIcon from '@mui/icons-material/History'
import HomeIcon from '@mui/icons-material/Home'
import LandslideIcon from '@mui/icons-material/Landslide'
import OilBarrelIcon from '@mui/icons-material/OilBarrel'
import PeopleIcon from '@mui/icons-material/People'
import PriceCheckIcon from '@mui/icons-material/PriceCheck'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications'
import { ReactNode } from 'react'
import { Permission } from '../types/User'
import { GlobalCatalog, globalCatalogs } from '../types/Platform'
import { PLATFORM_ROOT } from '../utils/platformMode'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import BusinessIcon from '@mui/icons-material/Business'
import DashboardIcon from '@mui/icons-material/Dashboard'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import PublicIcon from '@mui/icons-material/Public'
import StraightenIcon from '@mui/icons-material/Straighten'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline'

export enum MenuType {
  Item = 'item',
  Submenu = 'submenu',
}

export interface BaseMenu {
  title: string
  icon: ReactNode
  allowedPermission?: Permission | Permission[]
}

export interface MenuItem extends BaseMenu {
  type: MenuType.Item
  path: string
}

export interface MenuWithSubmenu extends BaseMenu {
  type: MenuType.Submenu
  children: MenuItem[]
}

export type MenuConfig = MenuItem | MenuWithSubmenu

const catalogIcons: Record<GlobalCatalog, ReactNode> = {
  [GlobalCatalog.FarmJobType]: <LandslideIcon />,
  [GlobalCatalog.FarmProductType]: <SpaIcon />,
  [GlobalCatalog.FarmExpenseType]: <ReceiptLongIcon />,
  [GlobalCatalog.ProductInventoryCategory]: <CategoryIcon />,
  [GlobalCatalog.ProductMeasure]: <StraightenIcon />,
  [GlobalCatalog.Bank]: <AccountBalanceIcon />,
}

const navConfig: MenuConfig[] = [
  {
    type: MenuType.Item,
    title: 'Inicio',
    path: '/',
    icon: <HomeIcon />,
  },
  {
    type: MenuType.Item,
    title: 'Reporte Trabajo',
    path: '/reporte-trabajo',
    icon: <AutoStoriesIcon />,
  },
  {
    type: MenuType.Submenu,
    title: 'Planilla',
    icon: <RequestQuoteIcon />,
    allowedPermission: [
      Permission.ViewCalculatedPayroll,
      Permission.ViewPayrollHistory,
      Permission.AdminPayroll,
    ], //This is an or condition, so if the user has any of these permissions, the menu will be shown
    children: [
      {
        type: MenuType.Item,
        title: 'Planilla Actual',
        path: '/planilla/calcular-pagar',
        icon: <CalculateIcon />,
      },
      {
        type: MenuType.Item,
        title: 'Planillas Pagadas',
        path: '/planilla',
        icon: <PriceCheckIcon />,
        allowedPermission: [
          Permission.ViewPayrollHistory,
          Permission.AdminPayroll,
        ],
      },
    ],
  },
  {
    type: MenuType.Item,
    title: 'Fincas',
    path: '/fincas',
    icon: <ForestIcon />,
  },
  {
    type: MenuType.Item,
    title: 'Proyectos',
    path: '/proyectos',
    icon: <EventAvailableIcon />,
  },
  {
    type: MenuType.Item,
    title: 'Plantillas',
    path: '/plantillas-proyecto',
    icon: <ViewTimelineIcon />,
    allowedPermission: Permission.AdminFarms,
  },
  {
    type: MenuType.Item,
    title: 'Empleados',
    path: '/empleados',
    icon: <PeopleIcon />,
  },
  {
    type: MenuType.Submenu,
    title: 'Inventario Productos',
    icon: <OilBarrelIcon />,
    children: [
      {
        type: MenuType.Item,
        title: 'Inventario',
        path: '/inventario-productos',
        icon: <OilBarrelIcon />,
      },
      {
        type: MenuType.Item,
        title: 'Historial',
        path: '/inventario-productos/historial',
        icon: <HistoryIcon />,
      },
    ],
  },
  {
    type: MenuType.Submenu,
    title: 'Reportes',
    icon: <AssessmentIcon />,
    allowedPermission: Permission.AdminFarms,
    children: [
      {
        type: MenuType.Item,
        title: 'Todos los reportes',
        path: '/reportes',
        icon: <SummarizeIcon />,
      },
      {
        type: MenuType.Item,
        title: 'Hectáreas sembradas',
        path: '/reportes/hectareas-sembradas',
        icon: <GrassIcon />,
      },
      {
        type: MenuType.Item,
        title: 'Hectáreas sin sembrar',
        path: '/reportes/hectareas-sin-sembrar',
        icon: <TerrainIcon />,
      },
    ],
  },
  {
    type: MenuType.Submenu,
    title: 'Configuración',
    icon: <SettingsApplicationsIcon />,
    allowedPermission: [Permission.ViewSettings, Permission.AdminSettings], //This is an or condition, so if the user has any of these permissions, the menu will be shown
    children: [
      {
        type: MenuType.Item,
        title: 'Trabajos Empleados',
        path: '/trabajos-empleados',
        icon: <EngineeringIcon />,
      },
      {
        type: MenuType.Item,
        title: 'Trabajos finca',
        path: '/trabajos-fincas',
        icon: catalogIcons[GlobalCatalog.FarmJobType],
      },
      {
        type: MenuType.Item,
        title: 'Productos finca',
        path: '/productos-fincas',
        icon: catalogIcons[GlobalCatalog.FarmProductType],
      },
      {
        type: MenuType.Item,
        title: 'Tipos de gasto',
        path: '/tipos-gastos-fincas',
        icon: catalogIcons[GlobalCatalog.FarmExpenseType],
      },      
      {
        type: MenuType.Item,
        title: 'Usuarios',
        path: '/usuarios',
        icon: <GroupIcon />,
      },
    ],
  },
]

/**
 * Menu of the platform area (/plataforma). It is shown instead of navConfig, never next to it,
 * and every entry requires the platform identity.
 */
export const platformNavConfig: MenuConfig[] = [
  {
    type: MenuType.Item,
    title: 'Inicio plataforma',
    path: PLATFORM_ROOT,
    icon: <DashboardIcon />,
    allowedPermission: Permission.PlatformAdmin,
  },
  {
    type: MenuType.Submenu,
    title: 'Catálogos globales',
    icon: <PublicIcon />,
    allowedPermission: Permission.PlatformAdmin,
    children: globalCatalogs.map((definition) => ({
      type: MenuType.Item,
      title: definition.title,
      path: `${PLATFORM_ROOT}/catalogos/${definition.slug}`,
      icon: catalogIcons[definition.catalog],
    })),
  },
  {
    type: MenuType.Item,
    title: 'Clientes',
    path: `${PLATFORM_ROOT}/clientes`,
    icon: <BusinessIcon />,
    allowedPermission: Permission.PlatformAdmin,
  },
  {
    type: MenuType.Item,
    title: 'Plantillas de proyecto',
    path: `${PLATFORM_ROOT}/plantillas`,
    icon: <ViewTimelineIcon />,
    allowedPermission: Permission.PlatformAdmin,
  },
  {
    type: MenuType.Item,
    title: 'Bitácora',
    path: `${PLATFORM_ROOT}/bitacora`,
    icon: <ManageSearchIcon />,
    allowedPermission: Permission.PlatformAdmin,
  },
]

export default navConfig